import { Audio } from '../../../dorian-shared/types/audio/audio';

/**
 * Derives the S3 bucket base URL from the loaded audios list.
 *
 * Each Audio record satisfies: audioUrl = bucketUrl + path
 * (e.g. audioUrl = "https://cdn.example.com/audio/custom/1/music/track.mp3",
 *        path    = "audio/custom/1/music/track.mp3")
 *
 * Finds the first record where both fields are present and audioUrl ends with
 * path, then strips the suffix to recover the bucket URL.
 *
 * Returns null when the list is empty or no record has both fields with a
 * matching suffix (e.g. placeholder / CDN-rewritten URLs).
 */
export function deriveAudioBucketUrl(audios: Audio[]): string | null {
  const match = audios.find(
    ({ audioUrl, path }) => audioUrl && path && audioUrl.endsWith(path),
  );
  if (!match) return null;
  return match.audioUrl.slice(0, match.audioUrl.length - (match.path as string).length);
}
